import { Drawer, Tag, Divider, Collapse, Row, Col, Button, Space, Card } from 'antd';
import { CheckCircleFilled, CloseCircleFilled, FilePdfOutlined } from '@ant-design/icons';

import { TIME } from '../../../../../../services/util';

import { DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL, DRIVER_PRETRIP_RISK_LABEL, DRIVER_PRETRIP_RISK_COLOR } from '../../../../../../constants/template/driver';

// Warna status badge (sesuaikan dengan status yang ada)
const SUBMISSION_STATUS_COLOR = {
  ready_to_verify: { bg: '#EDE9FE', text: '#6D28D9' },
  verified: { bg: '#DCFCE7', text: '#15803D' },
  pending: { bg: '#FEF3C7', text: '#B45309' },
};

const MeterCard = ({ label, value, sourceLabel, sourceValue, timestamp, valueColor }) => (
  <Col span={12}  >
    <Card>
        <h4 style={{ margin: 0, color: '#374151' }}>{label}</h4>
        <div style={{ margin: '8px 0' }}>
        <span style={{ fontSize: 28, fontWeight: 700, color: valueColor }}>
            {value || '-'}
        </span>{' '}
        <span style={{ fontSize: 14, color: '#6B7280' }}>KM</span>
        </div>
        <div style={{ color: '#6B7280', fontSize: 13 }}>{sourceLabel}</div>
        {sourceValue && (
        <div style={{ color: '#6B7280', fontSize: 13, marginBottom: 8 }}>
            Source: {sourceValue}
        </div>
        )}
        <div style={{ color: '#9CA3AF', fontSize: 12 }}>
        📅 {timestamp}
        </div>
    </Card>
  </Col>
);

const PretripContentDrawer = ({ isOpenDrawer, setIsOpenDrawer, newData, pretrips, exportDetailToPDFHDLR }) => {

    return (
        <Drawer
            title="Submission Detail"
            open={isOpenDrawer}
            onClose={() => setIsOpenDrawer(false)}
            width={450}
            footer={
                <Row gutter={10}>
                    <Col span={12}>
                        <Button block onClick={() => setIsOpenDrawer(false)}>
                            Close
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button
                            block
                            type="primary"
                            style={{ background: '#111827', borderColor: '#111827' }}
                            icon={<FilePdfOutlined />}
                            onClick={exportDetailToPDFHDLR}
                        >
                            Verify & Download PDF
                        </Button>
                    </Col>
                </Row>
            }
        >
            <div id="pdf">
                {/* Status Badge */}
                <Tag
                    style={{
                        background: SUBMISSION_STATUS_COLOR[newData.status]?.bg || '#EDE9FE',
                        color: SUBMISSION_STATUS_COLOR[newData.status]?.text || '#6D28D9',
                        border: 'none',
                        borderRadius: 20,
                        padding: '4px 14px',
                        fontWeight: 600,
                    }}
                >
                    {newData.statusLabel || 'Ready to Verify'}
                </Tag>

                {/* Driver / Vehicle */}
                <Row gutter={16} style={{ marginTop: 20 }}>
                    <Col span={12}>
                        <h4 style={{ margin: 0, color: '#374151' }}>Driver</h4>
                        <p style={{ margin: '4px 0 0', color: '#111827' }}>{newData.driver}</p>
                    </Col>
                    <Col span={12}>
                        <h4 style={{ margin: 0, color: '#374151' }}>Vehicle</h4>
                        <p style={{ margin: '4px 0 0', color: '#111827' }}>{newData.plate}</p>
                    </Col>
                </Row>

                {/* Date / Risk */}
                <Row gutter={16} style={{ marginTop: 16 }}>
                    <Col span={12}>
                        <h4 style={{ margin: 0, color: '#374151' }}>Date</h4>
                        <p style={{ margin: '4px 0 0', color: '#111827' }}>
                        {TIME.parseDate(newData.createdAt)}
                        </p>
                    </Col>
                <Col span={12}>
                    <h4 style={{ margin: 0, color: '#374151' }}>Risk</h4>
                    <Tag
                    color={DRIVER_PRETRIP_RISK_COLOR[DRIVER_PRETRIP_RISK_LABEL[newData.risk]]}
                    style={{ marginTop: 4 }}
                    >
                    {DRIVER_PRETRIP_RISK_LABEL[newData.risk]}
                    </Tag>
                </Col>
                </Row>

                <p style={{ marginTop: 16, color: '#374151' }}>
                <b>Submitted at</b>{' '}
                <span style={{ color: '#6B7280' }}>{TIME.parseTime(newData.createdAt)}</span>
                </p>

                <Divider style={{ margin: '12px 0' }} />

                {/* Meter Reading */}
                <h3 style={{ marginBottom: 12 }}>Meter Reading</h3>
                <Row gutter={10}>
                    <MeterCard
                        label="Before Trip"
                        value={newData.odometerStart}
                        valueColor="#2563EB"
                        sourceLabel="Submitted by Driver"
                        timestamp={TIME.parseDate(newData.createdAt) + ', ' + TIME.parseTime(newData.createdAt)}
                    />
                    <MeterCard
                        label="After Trip"
                        value={newData.odometerEnd}
                        valueColor="#16A34A"
                        sourceLabel="Auto-filled by System"
                        sourceValue={newData.odometerEndSource || 'GPS Trip Report'}
                        timestamp={
                        newData.odometerEndAt
                            ? TIME.parseDate(newData.odometerEndAt) + ', ' + TIME.parseTime(newData.odometerEndAt)
                            : '-'
                        }
                    />
                </Row>

                {newData.odometerEnd && (
                <div
                    style={{
                    marginTop: 12,
                    background: '#DCFCE7',
                    color: '#15803D',
                    padding: '10px 14px',
                    borderRadius: 8,
                    fontSize: 14,
                    }}
                >
                    <CheckCircleFilled style={{ marginRight: 8 }} />
                    After odometer has been auto-filled by system.
                </div>
                )}

                <Divider style={{ margin: '20px 0' }} />

                {/* Checklist Summary */}
                <Row justify="space-between" align="middle" style={{ marginBottom: 8 }}>
                <h3 style={{ margin: 0 }}>Checklist Summary</h3>
                <span className='ButtonLink' aria-hidden='true' onClick={() => {/* handler lihat semua item */}}>View All Items</span>
                </Row>

                <Collapse
                    bordered
                    expandIconPosition="end"
                    style={{ background: '#fff' }}
                    items={Object.keys(pretrips).map((ptc, i) => {
                        const items = pretrips[ptc] || [];
                        const passedCount = items.filter((it) => it.isChecked).length;
                        const allPassed = passedCount === items.length;

                        return {
                        key: i,
                        label: (
                            <Space>
                            {allPassed ? (
                                <CheckCircleFilled style={{ color: '#16A34A' }} />
                            ) : (
                                <CloseCircleFilled style={{ color: '#DC2626' }} />
                            )}
                            <span style={{ fontWeight: 600 }}>
                                {DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL[ptc]}
                            </span>
                            </Space>
                        ),
                        extra: (
                            <span style={{ color: allPassed ? '#16A34A' : '#DC2626', fontWeight: 500 }}>
                            {passedCount} / {items.length} Passed
                            </span>
                        ),
                        children: items.map((pt, j) => (
                            <div
                            key={j}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                padding: '6px 0',
                                color: pt.isChecked ? '#111827' : '#DC2626',
                            }}
                            >
                            {pt.isChecked ? (
                                <CheckCircleFilled style={{ color: '#16A34A' }} />
                            ) : (
                                <CloseCircleFilled style={{ color: '#DC2626' }} />
                            )}
                            {pt.item}
                            </div>
                        )),
                        };
                    })}
                />

                <Divider style={{ margin: '20px 0' }} />

                {/* Driver Note */}
                <h3 style={{ marginBottom: 8 }}>Driver Note</h3>
                <p style={{ color: '#374151' }}>{newData.note || '-'}</p>

                <Divider style={{ margin: '20px 0' }} />

                {/* Verification */}
                <h3 style={{ marginBottom: 8 }}>Verification</h3>
                <p style={{ color: '#374151' }}>By clicking "Verify & Download PDF", you confirm that:</p>
                <div>
                <p><span className="lb-check">✓</span> All checklist items have been reviewed.</p>
                <p><span className="lb-check">✓</span> Odometer before and after are correct.</p>
                <p><span className="lb-check">✓</span> This report will be marked as verified and cannot be edited.</p>
                </div>

                <h4 style={{ marginTop: 16, marginBottom: 4 }}>Verified By</h4>
                <p style={{ color: '#2563EB' }}>
                {newData.verifiedBy || 'Auto from logged-in Admin / SHO / SHS'}
                </p>
            </div>
        </Drawer>
    )
}

export default PretripContentDrawer